import { useState, useEffect } from "react";

type Location = {
    lat: number | null;
    lng: number | null;
};

type GeolocationError = string | null;

const useGeolocation = () => {
    const [location, setLocation] = useState<Location>({ lat: null, lng: null });
    const [error, setError] = useState<GeolocationError>(null);

    useEffect(() => {
        if ("geolocation" in navigator) {
            const handleSuccess = (position: GeolocationPosition) => {
                const { latitude, longitude } = position.coords;
                setLocation({ lat: latitude, lng: longitude });
            };

            const handleError = (error: GeolocationPositionError) => {
                setError(error.message);
            };

            const options: PositionOptions = {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0,
            };

            navigator.geolocation.getCurrentPosition(handleSuccess, handleError, options);
        } else {
            setError("La geolocalización no está disponible en este navegador.");
        }
    }, [navigator.geolocation]);

    return { location, error };
};

export default useGeolocation;
